<!-- This is for the storefront, not ops -->
<script>
	import autofocus_directive from 'shared/autofocus_directive'

	export let autofocus = false
	export let placeholder = null
	export let value
</script>

<select
	{...$$restProps}
	bind:value
	on:change
	on:blur
	on:focus
	use:autofocus_directive={autofocus}
	data-showing-placeholder={placeholder && value === null}
>
	{#if placeholder}
		<option value={null} disabled hidden>{placeholder}</option>
	{/if}
	<slot></slot>
</select>

<style>
	select {
		font-size: 16px;
		background-color: var(--better-contrast-background);
		border: 1px solid var(--input-border-gray);
		color: #ddd;
		padding: 0.5em;
		border-radius: 4px;
		width: 100%;
		height: 40px;
		font-family: "Protipo Wide", "Helvetica Neue", Helvetica, Arial, sans-serif;
		line-height: normal;
	}

	select[disabled] {
		opacity: 0.5;
	}

	select :global(option) {
		color: #c6c6c6;
		background-color: #222;
		font-family: "Protipo Wide", "Helvetica Neue", Helvetica, Arial, sans-serif;
	}

	select[data-showing-placeholder=true], select :global(option[disabled]) {
		color: #979797;
	}

	select:focus {
		-webkit-box-shadow: 0 0 0 3px var(--trex-green);
		box-shadow: 0 0 0 3px var(--trex-green);
		outline: none;
	}
</style>
